<template>
  <div class="org-logo-small">
    <div :class="theme">
      <img :src="url + OrganizationLogo.objectKey" height="35"/>
      <label>{{ pageTitle }}</label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrgLogo',
  props: {
    org: {
      type: Object
    }
  },
  data () {
    return {
      theme: '',
      pageTitle: '',
      OrganizationLogo: { objectKey: 'spacer.gif' },
      url: 'https://techcar-dev.s3.amazonaws.com/'
    }
  },
  mounted () {
    this.updateValue()
  },
  methods: {
    updateValue () {
      if (this.org) {
        this.theme = this.org.theme || 'black'
        this.pageTitle = this.org.pageTitle || 'Organisation'
        this.OrganizationLogo = this.org.OrganizationLogo || { objectKey: 'spacer.gif' }
      }
    }
  },
  watch: {
    'org': 'updateValue'
  }
}
</script>



// WEBPACK FOOTER //
// src/components/OrgLogo.vue